export enum GcpDeliveryModelEnum {
  VM = 'VM on customer tenancy',
  SAAS = 'SaaS on Google Cloud',
  OTHER = 'Other',
}
